"use strict";
export default function(model, mailbox, path) {
  return {
    value: model.getIn(path),
    requestChange: function(value) {
      return mailbox.sendPayload([path, value]);
    }
  };
}
